<template>
  <v-card outlined>
    <v-card-text class="pa-3">
      <v-row>
        <v-col cols="12">
          <v-tooltip
            top
            color="primary"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model.trim="enderecoDataLocale.nome"
                dense
                outlined
                label="Nome"
                hide-details="auto"
                validate-on-blur
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <span>Nome de identificação do endereço</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model.trim="enderecoDataLocale.cep"
            v-mask="'#####-###'"
            dense
            outlined
            label="Cep"
            hide-details="auto"
            validate-on-blur
            @change="handleCepChange"
          />
        </v-col>

        <v-col
          cols="12"
          md="8"
        >
          <v-text-field
            v-model.trim="enderecoDataLocale.rua"
            dense
            outlined
            label="Rua"
            hide-details="auto"
            validate-on-blur
            :filled="!ruaFoiPreenchidaPelaApiDosCorreios ? false : true"
            :disabled="!ruaFoiPreenchidaPelaApiDosCorreios ? false : true"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model.trim="enderecoDataLocale.numero"
            dense
            outlined
            label="Número"
            validate-on-blur
            hide-details="auto"
            :rules="[v => (cepFoiPreenchidoCorretamente ? (!!v && v.length <= 10) || 'Máximo de 10 caracteres' : true)]"
          />
        </v-col>

        <v-col
          cols="12"
          md="5"
        >
          <v-text-field
            v-model.trim="enderecoDataLocale.complemento"
            dense
            outlined
            label="Complemento"
            hide-details="auto"
            validate-on-blur
          />
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model.trim="enderecoDataLocale.estado"
            dense
            outlined
            label="Estado"
            filled
            disabled
            hide-details="auto"
            validate-on-blur
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model.trim="enderecoDataLocale.bairro"
            dense
            outlined
            label="Bairro"
            hide-details="auto"
            validate-on-blur
            :filled="!bairroFoiPreenchidoPelaApiDosCorreios ? false : true"
            :disabled="!bairroFoiPreenchidoPelaApiDosCorreios ? false : true"
          />
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model.trim="enderecoDataLocale.cidade"
            dense
            outlined
            label="Cidade"
            filled
            disabled
            hide-details="auto"
            validate-on-blur
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model.trim="enderecoDataLocale.pontoDeReferencia"
            dense
            outlined
            label="Ponto de referência"
            hide-details="auto"
            validate-on-blur
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { watch, watchEffect } from '@vue/composition-api'
import useDadosCorreios from '@/composables/useDadosCorreios'

export default {
  props: {
    enderecoData: {
      type: Object,
      required: true,
    },
    atualizarEndereco: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const {
      enderecoData: enderecoDataLocale,
      bairroFoiPreenchidoPelaApiDosCorreios,
      ruaFoiPreenchidaPelaApiDosCorreios,
      cepFoiPreenchidoCorretamente,
      handleCepChange,
    } = useDadosCorreios()

    watchEffect(() => {
      if (props.enderecoData) {
        enderecoDataLocale.value = props.enderecoData
      }
    })

    watch(
      () => enderecoDataLocale,
      v => {
        props.atualizarEndereco(v)
      },
      { deep: true },
    )

    return {
      enderecoDataLocale,
      ruaFoiPreenchidaPelaApiDosCorreios,
      bairroFoiPreenchidoPelaApiDosCorreios,
      cepFoiPreenchidoCorretamente,
      handleCepChange,
    }
  },
}
</script>
